import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, Button, Input, Select } from 'antd';
import { IMaskInput } from "react-imask";

export interface MasterRateEditModalProps extends PopupProps {
    item: MasterRateItemDto;
}

const MasterRateEditModal = ({ isOpen, onClose, item }: MasterRateEditModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
    const [isFormDone, setIsFormDone] = useState<boolean>(false);
    const [standard, setStandard] = useState<string>(item.standard);
   /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();

   /* ======================================================
   * events
   * ====================================================== */
    const onCancel = () => {
        onClose?.(false);
    };
        
    const onSubmit = (e) => {
        onClose?.(true, {year_id: item.year_id, lecture_type1: item.lecture_type1, standard: e.standard, price: e.price, rate: e.rate});
      };

    const onChangeForm = () => { 
        setIsFormDone(
            (form.getFieldValue('standard') === 'SALE' && form.getFieldValue('rate') > 0) ||
            (form.getFieldValue('standard') === 'TIME' && form.getFieldValue('price') > 0 && form.getFieldValue('rate') > 0) ||
            (form.getFieldValue('standard') === 'NONE')
        );
    };      
   
  /* ======================================================
   * effects
   * ====================================================== */

    useEffect(() => {
        form.setFieldsValue({
            standard: item.standard || 'NONE',
            price: item.price || 0,
            rate: item.rate || 0,
        });
    }, []);

    return (
        <ModalWrapper open={isOpen} onCancel={onCancel} width={450} title={`[${item.year_id}] 매출비율수정`} closable>
            <Form
                form={form}
                name="saleRate"
                layout="horizontal"  
                labelCol={{ flex: '125px' }}
                onFieldsChange={onChangeForm}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                <Form.Item label={'강의구분'}>
                    <label>{item.lecture_name}</label>   
                </Form.Item> 
                <Form.Item name="standard" label={'기준'} rules={[{ required: true, message: '' }]}>
                    <Select 
                        options={[{label:'매출', value:'SALE'}, {label:'강의시간당', value:'TIME'}, {label:'제외', value:'NONE'}]}                        
                        style={{width: '100px'}}
                        onSelect={setStandard}
                    />                    
                </Form.Item>  
                {standard === 'TIME' && (
                <Form.Item name="price" label={'기준매출'} rules={[{ required: true, message: '' }]}>
                    <IMaskInput 
                        min={0} 
                        mask = {Number}
                        thousandsSeparator={','}
                        className={'ant-input'} 
                        unmask={'typed'} 
                        onAccept = {((value, mask) => form.setFieldValue('price', value))}/>                    
                </Form.Item>  
                )}               
                {standard !== 'NONE' && (
                <Form.Item name="rate" label={'비율'} rules={[{ required: true, message: '' }]}>
                    <Input type={'number'} />
                </Form.Item>  
                )}                
                <ButtonGroup className={'buttonsWrapper'}>
                    <Button onClick={onCancel}>취소</Button>
                    <Button htmlType="submit"  type="primary" disabled={!isFormDone}>{'저장'}</Button>
                </ButtonGroup>                
            </Form>
        </ModalWrapper>  
    )    
};

export default React.memo(MasterRateEditModal);    